import React, { useEffect, useMemo } from 'react';

import { useMutation } from '../hooks/graph';
const controller = new AbortController();

function MeConnectorDelete({ providers, hooks, connector, onSuccess }) {
	const [ connectorDelete ] = useMutation('connectorDelete', controller);

	const connectorHooks = useMemo(() => connector && hooks ?
		hooks.filter(item => item.connector?.id == connector.id) : []
	, [connector]);

	const onSubmit = () => {
		connectorDelete({
			id: connector.id,
		}).then(() => {
			onSuccess(); // refetch and more
		}).catch(() => {
			// obsoleted / setError('submit', {message: 'Error: ' + err.message}); // temporal message
		});
	};

	useEffect(() => () => controller.abort(), []); // abort on unmount

	return (
		<div className="modal" id="connectorDeleteModal" tabIndex="-1" aria-labelledby="connectorDeleteModalLabel">
			<div className="modal-dialog">
				{
					connector && (
						<div className="modal-content">

							<div className="modal-header">
								<h5 className="modal-title" id="connectorDeleteModalLabel">Confirmation</h5>
								<button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
							</div>

							<div className="modal-body">
								{
									connectorHooks?.length ? (
										<div>
											<p>You are about to remove the {providers[connector.providerName].title} { connector.accounts[0]?.id && <span>(accounts: #{connector.accounts.map(item => item.id).join(', ')})</span> } brokerage connection.
											Doing so will remove all {connectorHooks?.hooks?.lemgth} webhooks connected to this brokerage, which means that they will stop working.</p>

											<p>You won&apos;t be able to restore removed webhooks, but you can create new ones in case if you connect a brokerage again.</p>

											<p>Are you sure you want to proceed?</p>
										</div>
									) : (
										<div>
											<p>Are you sure you want to remove the {providers[connector.providerName].title} { connector.accounts[0]?.id && <span>(accounts: #{connector.accounts.map(item => item.id).join(', ')})</span> } brokerage connection?</p>
										</div>
									)
								}
							</div>

							<div className="modal-footer">
								<button type="button" className="btn btn-outline-secondary" data-bs-dismiss="modal">Cancel</button>
								<button type="button" className="btn btn-danger" onClick={onSubmit} data-bs-dismiss="modal">Confirm</button>
							</div>

						</div>
					)
				}
			</div>
		</div>
	);
}

export default MeConnectorDelete;
